import React from 'react';

const AddRuleButton = ({ onClick, disabled }) => {
  return (
    <button
      type="button"
      className="aud-v2-add-rule"
      onClick={onClick}
      disabled={disabled}
    >
      <span className="material-icons">add_circle_outline</span>
      <span className="aud-v2-add-rule__text">Add rule to set</span>
    </button>
  );
};

export default AddRuleButton;
